import apps from '../configs/apps.json'
export default {
    V (data) {
        return apps[data]
    }
}